<!--
 * @Author: xxb
 * @Date: 2020-04-13 13:30:18
 * @LastEditTime: 2020-04-13 13:30:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \H5Reset\src\components\toast\toast.vue
 -->
<template>
  <div class="toast" v-show="visible">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "toast",
  data() {
    return {
      message: "", // 消息文字
      duration: 2000, // 显示时长，毫秒
      closed: false, // 用来判断消息框是否关闭
      timer: null, // 计时器
      visible: false, // 是否显示
    };
  },
  mounted() {
    this.startTimer();
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.destroyElement();
      }
    },
  },
  methods: {
    destroyElement() {
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
    startTimer() {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.closed = true;
          clearTimeout(this.timer);
        }
      }, this.duration);
    },
  },
};
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 2rem;
  max-width: 4rem;
  font-size: 0.26rem;
  text-align: center;
  padding: 0.15rem 0.3rem;
  border-radius: 0.1rem;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
}
</style>
